import { Component } from '@angular/core';
import { ORCIDKeywordEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Keywords') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidkeyword-form',
    templateUrl: './orcidkeyword.form.component.html'
})
export class ORCIDKeywordFormComponent extends BaseFormComponent {
    public record!: ORCIDKeywordEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

